import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Box, Button, Icon } from "@chakra-ui/react";
import { BsThreeDots } from "@onemind-services-llc/react-icons-ng/bs";
import { usePagination, DOTS } from "./usePagination";
import { Select } from "../../../Form/Select";
/** This component provides navigation buttons for pagination.
 * - For UI of this component to work properly create Button component variant named `pagination-btn` in Chakra-UI theme
 */
export const Pagination = (props) => {
    const { currentPage, setCurrentPage, totalCount, pageSize, setPageSize, siblingCount = 1, } = props;
    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize,
    });
    const lastPage = paginationRange[paginationRange.length - 1];
    const onNext = () => {
        if (currentPage !== lastPage) {
            setCurrentPage(currentPage + 1);
        }
    };
    const onPrevious = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const handlePageSizeChange = (e) => {
        setPageSize(e.target.value);
        setCurrentPage(1);
    };
    return (_jsxs(Box, { display: "flex", justifyContent: "flex-end", alignItems: { base: "flex-end", md: "center" }, flexDirection: { base: "column", md: "row" }, m: "10px 0px", children: [paginationRange.length >= 2 && (_jsxs(Box, { order: { base: 2, sm: 1 }, className: "page-navigation", children: [_jsx(Button, { onClick: onPrevious, variant: "pagination-btn", isDisabled: currentPage === 1, m: "5px", "data-cy": "prev-btn", children: "Prev." }), paginationRange.map((pageNumber, index) => (_jsx(Fragment, { children: pageNumber === DOTS ? (_jsx(Button, { m: "5px 2px", alignItems: "center", cursor: "none", "data-cy": "page-btn", className: "page-btn-dots", children: _jsx(Icon, { as: BsThreeDots }) })) : (_jsx(Button, { onClick: () => setCurrentPage(pageNumber), m: "5px 2px", className: pageNumber === currentPage ? "pagination-btn" : "solid", variant: pageNumber === currentPage ? "pagination-btn" : "solid", "data-cy": "page-btn", id: `page-btn-${pageNumber}`, children: pageNumber })) }, index))), _jsx(Button, { onClick: onNext, variant: "pagination-btn", isDisabled: currentPage === lastPage, m: "5px", "data-cy": "next-btn", children: "Next." })] })), totalCount > 10 ? (_jsx(Box, { w: { base: "100%", sm: "160px" }, m: "5px", order: { base: 1, sm: 2 }, className: "page-size-selection", children: _jsx(Select, { value: pageSize, options: [
                        { label: "10 / Page", value: 10 },
                        { label: "25 / Page", value: 25 },
                        { label: "50 / Page", value: 50 },
                        { label: "100 / Page", value: 100 },
                    ], onChange: handlePageSizeChange, id: "page-size", name: "page-size" }) })) : null] }));
};
//# sourceMappingURL=pagination.js.map